import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAppDrawer, IPersonalAccountPartsVisibility } from './types/app-drawer-interface';
import { fetchAppDrawer } from './actions/fetch-app-drawer';

const initialState: IAppDrawer = {
    AppDrawer: {
        Statistics: false,
        InsuranceContracts: false,
        InsurancePrograms: false,
        ListOfInsuredPersons: false,
        Applications: false,
        InsuranceOfRelatives: false,
        BonusProgram: false,
        Projects: false
    },
    isLoadingAppDrawer: false,
    errorAppDrawer: []
};

export const AppDrawer = createSlice({
    name: 'AppDrawer',
    initialState,
    reducers: {
        resetAppDrawer: (state) => {
            state.AppDrawer = initialState.AppDrawer;
            state.isLoadingAppDrawer = false;
            state.errorAppDrawer = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAppDrawer.pending, (state) => {
                state.isLoadingAppDrawer = true;
            })
            .addCase(fetchAppDrawer.fulfilled, (state, action: PayloadAction<{ PersonalAccountPartsVisibility: IPersonalAccountPartsVisibility }>) => {
                state.isLoadingAppDrawer = false;
                state.AppDrawer = action.payload.PersonalAccountPartsVisibility;
                state.errorAppDrawer = [];
            })
            .addCase(fetchAppDrawer.rejected, (state, action) => {
                state.AppDrawer = initialState.AppDrawer;
                state.isLoadingAppDrawer = false;
                state.errorAppDrawer = action.payload as string[];
            });
    },
});

export const { resetAppDrawer } = AppDrawer.actions;
export default AppDrawer.reducer;